import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	lastUpdated: {
		id: 'software-code-code-page.pages.main-page.repositories.repository-list.repository-card.last-updated',
		defaultMessage: 'Last updated {dateString}',
		description: 'This text indicates when the code repository is updated recently',
	},
});
